import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLoader } from '@fortawesome/pro-solid-svg-icons/faLoader';
import React, { memo } from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';

import style from './loading-indicator.less';

const LoadingIndicator = ({ className = '', theme = 'grey', 'data-testid': testId, iconClassName, iconTitle = 'spinner' }) => {
  return (
    <div className={classnames(className, style['loading-indicator'], style[theme])} data-testid={testId}>
      <div className={style['icon-wrapper']}>
        <FontAwesomeIcon aria-hidden={false} aria-label={iconTitle} className={classnames(style.icon, iconClassName)} icon={faLoader} />
      </div>
    </div>
  );
};

LoadingIndicator.propTypes = {
  theme: PropTypes.oneOf(['white', 'grey']),
  className: PropTypes.string,
  'data-testid': PropTypes.string,
  iconClassName: PropTypes.string,
  iconTitle: PropTypes.string,
};

export default memo(LoadingIndicator);
